import React from "react";
import { Card, CardContent } from "./ui/card";

const features = [
  {
    title: "Comunicação Eficaz",
    description: "Aprenda técnicas para expressar sentimentos e necessidades de forma clara e respeitosa.",
    gradient: "from-primary/20 to-accent/20"
  },
  {
    title: "Resolução de Conflitos",
    description: "Transforme discussões em conversas produtivas que levam a soluções satisfatórias para ambos.",
    gradient: "from-accent/20 to-secondary/20"
  },
  {
    title: "Crescimento Conjunto",
    description: "Fortaleça seu vínculo e cresçam juntos através de cada desafio superado.",
    gradient: "from-secondary/20 to-primary/20"
  }
];

const Features = () => {
  return (
    <section className="py-20 px-4 bg-background">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            Como podemos ajudar seu relacionamento
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Ferramentas práticas e eficazes para fortalecer sua conexão
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <Card 
              key={index}
              className="group hover:shadow-elevated transition-all duration-300 border-2 hover:border-primary/50"
            >
              <CardContent className="p-8 space-y-4">
                <div className={`w-16 h-16 rounded-2xl bg-gradient-to-br ${feature.gradient} flex items-center justify-center group-hover:scale-110 transition-transform`}>
                  <div className="w-8 h-8 bg-primary rounded-full"></div>
                </div>
                
                <h3 className="text-2xl font-bold">
                  {feature.title}
                </h3>
                
                <p className="text-muted-foreground leading-relaxed">
                  {feature.description}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;